import React from 'react';
import { Dispatch, SetStateAction, useEffect, useState, useContext } from "react";
import { TAttributeValue, TFetchAttributeValues, TFinalAttributeValue, TLoading } from "../types";
import CustomSearchBar from "Components/GMS/Products/components/CustomSearchBar";
import CheckboxButtonWithLabel from "Components/Common/components/CheckboxButtonWithLabel";
import ViewMoreButton from "Components/Common/components/ViewMoreButton";
import { AttributeContext } from "../AttributeContext";

type MyProps = {
    attValues: TFinalAttributeValue[],
    setAttValues: Dispatch<SetStateAction<TFinalAttributeValue[]>>,
    loading: TLoading,
    setLoading: Dispatch<SetStateAction<TLoading>>,
    finalAttributeValues: TFinalAttributeValue[]
    setFinalAttributeValues: Dispatch<SetStateAction<TFinalAttributeValue[]>>,
    fetchAttributeValues: TFetchAttributeValues,
    attValuesCount: number,
    search: string|undefined
    setSearch: Dispatch<SetStateAction<string|undefined>>
}

export default function EditAttValues ({
  attValues,
  loading,
  setLoading,
  finalAttributeValues,
  setFinalAttributeValues,
  fetchAttributeValues,
  attValuesCount,
  search,
  setSearch
}: MyProps) {
  const [textField, setTextfield] = useState("");
  const { attributeLoading } = useContext(AttributeContext);
  function isEmpty(str: string) {
    function myTrim(x: string) {
      return x.replace(/^\s+|\s+$/gm, "");
    }

    return myTrim(str).length === 0;
  }

  function handleDelete(item: TFinalAttributeValue, index: number) {
    let obj = {
      ...item,
      edited: false,
      toggle: false,
      deleted: true,
      changed: true,
    };

    // will be a new value delete from finalAttributeValues 
    // not other changes necessary
    setFinalAttributeValues((prev) => {
        const nextValue = [...prev]
        const index = finalAttributeValues.findIndex((value) => value.value === item.value)
        // if already existing item thats not deleted
        if(index === -1 && item.id) nextValue.push(obj)
        // if newly create item is deleted
        if(index !== -1 && !item.id) nextValue.splice(index, 1)
        
        return nextValue
    })
  }

  function cancelAddEditDelete(item: TFinalAttributeValue, index:number) {
    if(!finalAttributeValues) return
    setFinalAttributeValues((prev) => {
        const nextValues = [...prev]
        if(index !== -1) nextValues.splice(index, 1);
        return nextValues
    })
  }

  function findDuplicates(value: string) {
    let index = finalAttributeValues.findIndex((i) => i.value === value) 
    let attIndex = attValues.findIndex((i) => i.value === value);

    return (index >= 0 || attIndex >= 0) ;
  }

  function handleCreate (e: React.KeyboardEvent<HTMLInputElement>) { 
    let newValue = (e.target as HTMLInputElement).value;
    if (e.key === "Enter") {
        e.preventDefault();
        if (!isEmpty(newValue)) {
        let splitValue = newValue
            .split(",")
            .filter((e, i, a) => a.indexOf(e) === i);
        splitValue.forEach((item) => {
            let duplicates = findDuplicates(item);
            if (!duplicates) {
            let obj = {
                id: null,
                value: item,
                active: true,
                edited: false,
                deleted: false,
                toggle: false,
                changed: true,
            };
            setFinalAttributeValues((prev) => prev ? [...prev, obj] : [obj])
            setTextfield("");
            } else {
            setLoading({
                status: "Error",
                message:
                "Duplicate values cannot be added and are removed.",
            });
            setTextfield("");
            setTimeout(() => {
                setLoading({
                status: "",
                message: "",
                });
            }, 5000);
            }
        });
        }
    }       
  }

  let deletedAttributes: TFinalAttributeValue[] = finalAttributeValues?.filter((item) => item.deleted) ?? [];
  const deletedAttributesValues = deletedAttributes.map((item) => item.value)
  // let notDeletedAttributes: TFinalAttributeValue[] = [...finalAttributeValues?.filter(item => !item.id), ...attValues.filter(item => !deletedAttributesValues.includes(item.value))] ?? []
  const notDeletedAttributes: TFinalAttributeValue[] = [
    ...(finalAttributeValues?.filter(item => !item.id) ?? []),
    ...attValues.filter(item => !deletedAttributesValues.includes(item.value))
  ];
  return (
    <div>
      <div>
        <div className="p-3">
        <input
          className="shadow-none form-control"
          placeholder={"Type values and press 'ENTER' button to add"}
          style={{
            fontWeight: "600",
            fontSize: "0.9rem",
          }}
          value={textField}
          onChange={(e) => {
            setTextfield(e.target.value);
          }}
          onKeyDown={handleCreate}
          id="AttributeValue"
          autoComplete="off"
        />   
        </div>
       
        <div style={{ minHeight: "50px" }} className="p-3 bg-gray">
          <div className="mb-3 tw-flex tw-flex-wrap tw-justify-between tw-items-center selected-category-heading">
            <span>
              Selected Attributes
            </span>
            <div className="tw-w-60">
              <CustomSearchBar 
                placeholder="Search Attribute Values"
                handleSearchChange = {(value) => setSearch(value)}
                value = {search}
                disabled={attributeLoading}
                delay={1000}
              />
            </div>
          </div>
          <div
            style={{ minHeight: "50px" }}
            className="flex-row flex-wrap gap-2 pb-3 d-flex align-items-center w-100"
          >
            {/* fi */}
            {notDeletedAttributes.length > 0 &&
              notDeletedAttributes
              .filter((item) => !item.deleted)
              .map((item, index) => {
                return <CheckboxButtonWithLabel
                key={index}
                defaultChecked={item.id !== null}
                handleDelete={() => {
                  if (
                    item.edited === true ||
                    item.deleted === true ||
                    item.id === null
                  ) {
                    cancelAddEditDelete(item, index);
                  } else {
                    handleDelete(item, index);
                  }
                }}
                id={item.id as string}
                label={item.value}
                theme={item.id === null ? "success" : "primary"}
                deleteButton={true}
              />
              })}

              <ViewMoreButton
                condition = {attValues.length < attValuesCount}
                state = {attValues.length >= attValuesCount}
                handleClick = {() => fetchAttributeValues(search, attValues.length, false)}
              />
                        
          </div>

        </div>
        <div className="p-3">
          <div className="mb-3 selected-category-heading">
            Deleted Attributes
            <span className="badge badge-light">
            </span>
          </div>
          <div className="flex-row flex-wrap gap-2 pb-3 d-flex align-items-center w-100">
            {deletedAttributes.length > 0 &&
              deletedAttributes.map((item, index) => {
                return <CheckboxButtonWithLabel
                    key={index}
                    defaultChecked={false}
                    handleClick={() => {
                      if (
                        item.edited === true ||
                        item.deleted === true ||
                        item.id === null
                      ) {
                        cancelAddEditDelete(item, index);
                      } else {
                        handleDelete(item, index);
                      }
                    }}
                    id={item.id as string}
                    label={item.value}
                    theme={"danger"}
                  />
              })}
          </div>
        </div>
      </div>
    </div>
  );
};
  